export const IMAGE_WIDTH_CAROUSEL = 308;
export const IMAGE_WIDTH_GRID = 800;
export const IMAGE_HEIGHT_CAROUSEL = 200;
export const IMAGE_HEIGHT_GRID = 500;
